export default "__VITE_ASSET__DB6FRXmX__"